import Model from './Model'
import get from 'lodash/get'
import isNil from 'lodash/isNil'
export default class Offer extends Model {

    resource()
    {
        return 'offers'
    }

    get status_friendly() {
        return get(this.statuses.find(stat => stat.id === this.status), 'text')
    }

    get status_color() {
        return get(this.statuses.find(stat => stat.id === this.status), 'color', 'default')
    }

    get statuses () {
        return [{
            id: 'ACTIVE',
            text: 'Activ',
            color: 'default'
        },{
            id: 'OFFERED',
            text: 'Ofertat',
            color: 'primary'
        },{
            id: 'FINALIZED',
            text: 'Finalizat',
            color: 'success'
        }, {
            id: 'CANCELED',
            text: 'Anulat',
            color: 'error'
        }]
    }
    get attachments() {
        return [{
            id: 'offer',
            text: 'Oferta',
            condition: (() => {
                return true
            })
        }, {
            id: 'proforma',
            text: 'Proforma',
            condition: (() => {
                return true
            })
        }, {
            id: 'estimateOfWork',
            text: 'Deviz',
            condition: (() => {
                return !isNil(get(this, 'eow_no'))
            })
        }, {
            id: 'invoice',
            text: 'Factura fiscala',
            condition: (() => {
                return !isNil(get(this, 'invoice'))
            })
        }, {
            id: 'invoiceRecipe',
            text: 'Chitanta factura fiscala',
            condition: (() => {
                return !isNil(get(this, 'invoice.recipe'))
            })
        }];
    }
    get availableAttachments() {
        return this.attachments.filter((item) => item.condition())
    }

    get downloadEndpoint() {
        return `${this.endpoint()}/download/offer`
    }

    get downloadDevizEndpoint() {
        return `${this.endpoint()}/download/deviz`
    }
}
